export default __webpack_public_path__ + "static/media/4.bd62f886.jpg";